export default "__VITE_ASSET__ed1aef34__"